import { EmbedLinkedDocBlockSchema } from '@blocksuite/hive-model';
import { BlockViewExtension } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';
import { literal } from 'lit/static-html.js';

import { EmbedLinkedDocBlockAdapterExtensions } from './adapters/extension';
import { LinkedDocSlashMenuConfigExtension } from './configs/slash-menu';
import { createBuiltinToolbarConfigExtension } from './configs/toolbar';

const flavour = EmbedLinkedDocBlockSchema.model.flavour;

export const EmbedLinkedDocBlockSpec: ExtensionType[] = [
  BlockViewExtension(flavour, model => {
    return model.parent?.flavour === 'hive:surface'
      ? literal`hive-embed-edgeless-linked-doc-block`
      : literal`hive-embed-linked-doc-block`;
  }),
  EmbedLinkedDocBlockAdapterExtensions,
  createBuiltinToolbarConfigExtension(flavour),
  LinkedDocSlashMenuConfigExtension,
].flat();
